module.exports = __webpack_public_path__ + "static/sleeping-cat-static-12ea468f244bf0abf2f9deae13fa9e7e.png";